import PropTypes from 'prop-types';
import React from 'react';

import './ProductDescription.scss';

const removeImgTags = (html) => {
  if (!html) return html;
  // Remove img tags
  let cleanedHtml = html.replace(/<img[^>]*>/gi, '');
  cleanedHtml = cleanedHtml.replace(/\s+style\s*=\s*(['"])((?:(?!\1).)*)\1/gi, '');
  return cleanedHtml;
};

const ProductDescription = ({ id, description }) => {

  return (
    <div id={id} data-testid={id} className='description-container'>
        <div className={'description show-more'} dangerouslySetInnerHTML={{ __html: removeImgTags(description) }} >
        </div>
    </div>
  )
}

ProductDescription.propTypes = {
    id: PropTypes.string,
    description: PropTypes.string
}

export default ProductDescription